import gender from "./gender";
import category from "./category";
import tableMarking from "./tableMarking";
import marking from "./marking";
import measure from "./measure";
import measureImages from "./measureImages";
import tableSize from "./tableSize";
import sizeMarking from "./sizeMarking";
import measureValue from "./measureValue";
import measureLimits from "./measureLimits";
import measurementInstruction from "./measurementInstruction";
import serviceUse from "./serviceUse";
import license from "./license";
import licenseServices from "./licenseServices";
import user from "./user";
import sizeAdvisor from "./sizeAdvisor";
import sizeAdvisorSize from "./sizeAdvisorSize";
import sizeAdvisorFit from "./sizeAdvisorFit";
import fit from "./fit";
import buttonStyle from "./buttonStyle";
import recommendedSize from "./recommendedSize";
import measures from "./measures";
import accessToken from "./accessToken";
import expiresIn from "./expiresIn";
import refreshToken from "./refreshToken";
import tokenType from "./tokenType";

export default {
  accessToken,
  expiresIn,
  refreshToken,
  tokenType,
  gender,
  category,
  tableMarking,
  marking,
  measure,
  measureImages,
  tableSize,
  sizeMarking,
  measureValue,
  measureLimits,
  measurementInstruction,
  serviceUse,
  license,
  licenseServices,
  user,
  sizeAdvisor,
  sizeAdvisorSize,
  sizeAdvisorFit,
  fit,
  buttonStyle,
  recommendedSize,
  measures
};
